export default "__VITE_ASSET__2d09b89a__"